<template>
  <div class="history-page">
    <AgeGate />
      <Header />
      <SmoothScroll>
        <div class="history" data-scroll-section data-scroll>
         <PageTitle :pageTitle="'ჟუჟუნას ისტორია'" :titleColor="'#044B30'"  :bgColor="'#FDCF18'" />
          <HistoryBlock />
          <VideoBlock />
          <HistorySlider />
        <Footer />
        </div>
      </SmoothScroll>
  </div>
</template>

<script>
import SmoothScroll from '@/components/SmoothScroll';
import HistoryBlock from '@/components/smartComponents/HistoryBlock';
import VideoBlock from '@/components/smartComponents/VideoBlock';
import HistorySlider from '@/components/smartComponents/HistorySlider';
import PageTitle from '@/components/layout/PageTitle';
import AgeGate from '@/components/smartComponents/AgeGate';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
export default {
components: {SmoothScroll, Header, PageTitle, Footer, HistoryBlock, VideoBlock, HistorySlider, AgeGate},
}
</script>

<style>

</style>